import React from 'react';
import { connect } from 'react-redux';
import AddressName from '../Components/AddressName';
import Coin from '../Components/Coin';

const mapStateToProps = (state) => {
  return {
    accountBalances: Object.values(state.accountBalances)
  };
};

const connectedRichestAccounts = ({accountBalances}) => (
  <div className="c-component c-richest-accounts">
    <h2>Richest Accounts</h2>
    <ul className="c-richest-accounts__list">
      {accountBalances
        .sort((a, b) => a.balance < b.balance)
        .slice(0, 20)
        .map((accountBalance) => (
          <li key={accountBalance.address} className="c-richest-accounts__list-item">
            <AddressName address={accountBalance.address}/>
            <Coin coin={accountBalance.balance}/>
          </li>
        ))}
    </ul>
  </div>
);

const RichestAccounts = connect(mapStateToProps)(connectedRichestAccounts);

export default RichestAccounts;


// WEBPACK FOOTER //
// ./src/components/AnalyticsPage/RichestAccounts.js